<template>
  <div class="appBody prh-main bg-grey-light w-100">
    <tabbar-component class="bigTab" :type="bigTab" :tabbarList="tabArr"></tabbar-component>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getTeacherById"
      class="bg-white">
      <card-component :cardList="zhiboList"
                      class="pb-3  my-2 colum-card zhibo-card" typeBlock="zhibo">
        <div class=" bg-white px-3 d-flex align-items-center justify-content-between">
          <h6 class="b-title px-0 mb-0 bg-white">直播</h6>
        </div>
      </card-component>

    </van-list>

    <little-footer></little-footer>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {List} from 'vant';

  Vue.use(List);

  import TabbarComponent from '@/components/tabbarComponent';
  import CardComponent from '@/components/cardComponent'
  import LittleFooter from '@/page/lecturer/components/littleFooter';

  export default {
    name: "lecZhiboList",
    components: {
      TabbarComponent,
      CardComponent,
      LittleFooter,
    },
    data() {
      return {
        tabArr: [],
        bigTab: 'bigTab',
        zhiboList: [],
        loading: false,
        finished: false,
        tid: ''
      }
    },
    mounted() {
      this.tid = this.$route.params.uid;
      this.getTeacherById();
      this.tabArr = [
        {
          title: '讲师',
          icon: '/static/img/index/zj-1.png',
          link: '/lecturer/' + this.tid
        },
        {
          title: '课程',
          icon: '/static/img/pro/course_nav.png',
          link: '/lecturer/course/list/' + this.tid
        },
        {
          title: '专栏',
          icon: '/static/img/pro/zhuanlan_nav.png',
          link: '/lecturer/zhuanlan/list/' + this.tid
        }
      ];
    },
    methods: {
      getTeacherById() {
        this.loading = true;
        this.$store.dispatch('getLectureById').then((res) => {
          this.zhiboList = res[0].zhiboList;
          this.loading = false;
          if (this.zhiboList.length < 10) {
            this.finished = true;
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
